import { createFileRoute } from '@tanstack/react-router';

interface VerifySearch {
  token?: string;
}

export const Route = createFileRoute('/auth/verify')({
  validateSearch: (search: Record<string, unknown>): VerifySearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
});
